import React, {Component} from "react";
import {AuthProvider} from "./context/authContext";
import config from "./config";

class Auth extends Component {
  state = {
    authenticated: false,
    user: {},
    access: [],
    is_admin: false,
    prop: {}
  };

  componentDidMount() {
    const usuario = localStorage.getItem('usuario');
    if (usuario) {
      this.setUser(JSON.parse(usuario))
    }
    document.title = config.SITE_TITLE
  }

  initiateLogin = ({ authenticated, prop, access, is_admin }) => {
    this.setState({ authenticated, prop, access, is_admin });
    if (prop) {
      if (prop.nombre_sistema) document.title = prop.nombre_sistema;
      if (prop.color_1) {
        const hex = prop.color_1.toString().replace(/^#+/, '');
        document.documentElement.style.setProperty('--accent-color', `#${hex}`);
      }
    }
  };

  updateProp = (newProp) => {
    this.setState(prevState => {
      const merged = { ...prevState.prop, ...newProp };
      if (merged.color_1) localStorage.setItem('solexx-color1', merged.color_1);
      if (merged.color_2) localStorage.setItem('solexx-color2', merged.color_2);
      if (merged.logo_url) localStorage.setItem('solexx-logo', merged.logo_url);
      if (merged.nombre_sistema) document.title = merged.nombre_sistema;
      if (merged.color_1) {
        const hex = merged.color_1.toString().replace(/^#+/, '');
        document.documentElement.style.setProperty('--accent-color', `#${hex}`);
      }
      return { prop: merged };
    });
  };

  logout = () => {
    const usuario = localStorage.getItem('usuario');
    if (usuario) {
      localStorage.removeItem('usuario');
    }
    this.setState({ authenticated: false, user: {},  });
  };

  setUser = (user) => {
    localStorage.setItem('usuario', JSON.stringify(user));
    this.setState({ user })
  }

  hasAccess = (access) => {
    if(this.state.is_admin) { return true }
    if (Array.isArray(access)) {
      return this.state.access.some(a => access.includes(a))
    }
    return this.state.access.includes(access);
  }

  render() {
    const authProviderValue = {
      ...this.state,
      initiateLogin: this.initiateLogin,
      updateProp: this.updateProp,
      logout: this.logout,
      setUser: this.setUser,
      hasAccess: this.hasAccess,
    };
    return (
      <AuthProvider value={authProviderValue}>
        {this.props.children}
      </AuthProvider>
    );
  }
}

export default Auth;
